// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"b03a6a87","205":"07a0d212","339":"fe6fd245","393":"210e5a01","427":"05808b36","456":"b915a028","637":"dc7ef3af"}[chunkId] + ".chunk.css";
};